import './css/TypingIndicator.css'

function TypingIndicator() {
    return (
        <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
        </div>
    );
}

export default TypingIndicator;
